'use strict';

import React, { PropTypes } from 'react';
import _ from 'lodash/fp';
import { roundToNearestThree } from '../utils/Channels';

require('styles/ChannelEntry.css');

class ChannelEntryComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {channel: this.props.channel};
  }

  handleChange(event) {
    let value = parseInt(event.target.value);
    if (_.isEmpty(event.target.value)) {
      value = 0;
    }

    this.setState((state) => {
      if (_.isNaN(value) || value > 999 || value < 0) {
        return state;
      } else {
        return {channel: value};
      }
    });
  }

  handleKeyPress(event, force) {
    const roundUp = (rem, delay) => {
      const {channel} = this.state;
      if (rem <= 0) {
        this.props.changeChannel(channel);
      } else {
        this.setState({channel: channel + 1});
        const newDelay = Math.floor(delay / 2);
        setTimeout(roundUp.bind(this, rem - 1, newDelay), newDelay);
      }
    };

    if (force || event.which === 13) {
      const {channel} = this.state;
      const nearestThree = roundToNearestThree(channel);

      if (nearestThree !== channel) {
        setTimeout(roundUp.bind(this, nearestThree - channel, 1000), 1000);
      } else {
        this.props.changeChannel(this.state.channel);
      }
    }
  }

  static propTypes = {
    channel: PropTypes.number.isRequired,
    changeChannel: PropTypes.func.isRequired
  }

  render() {
    return (
      <div className="channelentry-component">
        <p>Please enter a random number</p>
        <p>Between 0-333</p>
        <div className="channelentry-input">
          <input type="text"
                 value={this.state.channel}
                 onChange={this.handleChange.bind(this)}
                 onKeyDown={this.handleKeyPress.bind(this)}
                 name="channel"
                 ref="channelInput" />
         </div>
      </div>
    );
  }
}

ChannelEntryComponent.displayName = 'ChannelEntryComponent';

export default ChannelEntryComponent;



// WEBPACK FOOTER //
// ./src/components/ChannelEntryComponent.js